const hideRebuyProductDiscount = (productId, widgetId) => {
  const container = document.querySelector(`#rebuy-widget-${widgetId}`)
  const card = container.querySelector(`.product-id-${productId}`)
  const discountContainer = card.querySelector(
    `.rebuy-product-price.rebuy-has-discount`
  )

  if (discountContainer) {
    discountContainer.classList.toggle("rebuy-disable-discount")
  }
}

const rebuyProductDiscount = (widget) => {
  const container = document.querySelector(`#rebuy-widget-${widget.id}`)
  if (!container) return
  const cards = container.querySelectorAll(".rebuy-product-block")
  setTimeout(() => {
    cards.forEach((card) => {
      const productId = parseInt(
        card.classList.value
          .split(" ")
          .find((cl) => cl.includes("product-id-"))
          .replace("product-id-", "")
      )
      const product = widget.data.products.find(
        (product) => product.id === productId
      )
      const discountTag = product
        ? product.tags
            .split(", ")
            .find((tag) => tag.toLowerCase().includes("%off"))
        : ""

      const priceContainer = card.querySelector(".rebuy-product-price")
      const discountContainer = card.querySelector(".rebuy-discount-container")
      if (discountContainer) {
        discountContainer.remove()
      }
      priceContainer.classList.remove("rebuy-has-discount")

      if (discountTag) {
        const percent = parseInt(discountTag.replace("%OFF", ""))
        const price = card
          .querySelector(".rebuy-money.sale > span:last-child")
          .innerText.replace("$", "")

        if (discountTag.toLowerCase().includes("fake")) {
          if (!card.querySelector(".rebuy-discount")) {
            const compare = card
              .querySelector(".rebuy-money.compare-at > span:last-child")
              .innerText.replace("$", "")

            const discountPercent = parseInt(
              (((compare - price) / compare) * 100).toFixed(2)
            )

            priceContainer.classList.add("rebuy-has-discount-label")
            priceContainer.querySelector("div").insertAdjacentHTML(
              "afterend",
              `
                <span class="rebuy-discount">
                  ${discountPercent}%
                </span>
              `
            )
          }
        } else {
          const discount = price * (percent / 100)
          const priceWithDiscount = (price - discount).toFixed(2)

          priceContainer.classList.add("rebuy-has-discount")
          priceContainer.insertAdjacentHTML(
            "afterend",
            `
              <div class="rebuy-discount-container">
                <span class="rebuy-discount-percent">-${percent}%</span>
                <span class="rebuy-discount-price">$${priceWithDiscount}</span>
              </div>
            `
          )
        }

        const subscriptionCheckbox = card.querySelector(
          ".subscription-checkbox input"
        )
        if (subscriptionCheckbox) {
          subscriptionCheckbox.setAttribute(
            "onchange",
            `hideRebuyProductDiscount(${productId}, ${widget.id})`
          )
        }
      }
    })
  }, 500)
}

const promoProductChange = (widget) => {
  rebuyProductDiscount(widget)

  setTimeout(() => {
    let hide = false
    const widgetContainer = document.querySelector(
      `[data-rebuy-id="${widget.id}"]`
    )
    const widgetDiv = document.querySelector(`#rebuy-widget-${widget.id}`)

    if (widgetDiv) {
      hide = widgetDiv.classList.contains("is-hidden")
    } else {
      hide = false
    }

    if (hide) {
      widgetContainer.setAttribute("data-initialized", "false")
    } else {
      if (widgetContainer) {
        widgetContainer.setAttribute("data-initialized", "true")
      }
    }
  }, 500)
}

function insertAfter(referenceNode, newNode) {
  if (!referenceNode) return
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling)
}

const removeSubBtnFG = () => {
  const itemInfoContainer = document.querySelectorAll(
    ".rebuy-cart__flyout-item-info"
  )

  itemInfoContainer.forEach((item) => {
    const freeGiftLabel = item.querySelector(
      ".rebuy-cart__flyout-item-discount-message"
    )
    if (freeGiftLabel) {
      item.classList.add("is-gift")
    } else {
      item.classList.remove("is-gift")
    }
  })
}

const removeVariantByHandle = async (productHandle, cartItems) => {
  try {
    const response = await fetch(`/products/${productHandle}.js`)
    const data = await response.json()
    cartItems.map((item) => {
      if (item.handle === productHandle) {
        data.variants.map((variant) => {
          if (variant.id === item.variant_id) {
            fetch(`/cart/change?id=${variant.id}&quantity=0`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            })
              .then((response) => response.json())
              .then((data) => console.log(data))
              .catch((error) => console.error("Error:", error))
          }
        })
      }
    })
  } catch (err) {
    console.log(err)
  }
}

document.addEventListener("rebuy:cart.change", function () {
  setTimeout(() => {
    removeSubBtnFG()
  }, 1000)
})

document.addEventListener("rebuy.productsChange", function (event) {
  if (["166652"].includes(event.detail.widget.id)) {
    const removeProductHandle =
      event.detail.widget.data.metadata?.custom?.remove_product
    const cartItems = event.detail.widget.data.cart.items
    if (removeProductHandle) {
      removeVariantByHandle(removeProductHandle, cartItems)
    }
  }
})

document.addEventListener("rebuy:cart.change", function (event) {
  const cartCount = document.querySelectorAll("[data-cart-count]")
  cartCount.forEach((el) => (el.innerText = event.detail.cart.cart.item_count))
})

const addWidthHeightToImage = (widget, width, height) => {
  const container = document.querySelector(`#rebuy-widget-${widget.id}`)
  if (!container) return
  const images = container.querySelectorAll(".rebuy-product-image img")
  images.forEach((image) => {
    image.setAttribute("width", width)
    image.setAttribute("height", height)
  })
}
